<template>
  <div class="login-choice">
    <LoginHead />
    <div class="login-handle cus-style">
      <div class="tips">请选择您的角色</div>
      <div class="select-area">
        <el-select v-model="role" placeholder="请选择您的角色">
          <el-option
            v-for="item in roleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="login-btn">
        <van-button
          size="large"
          color="linear-gradient(to right, #5DD682, #5AFF8E)"
          @click="tagetJump"
          >下一步</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import LoginHead from "@/components/login/HeadWrap.vue";
import { mapActions } from "vuex";
export default {
  components: {
    LoginHead
  },
  data() {
    return {
      role: 0,
      roleOptions: [
        {
          value: 0,
          label: "选手"
        },
        {
          value: 1,
          label: "评委"
        },
        {
          value: 2,
          label: "报名服务单位"
        },
        {
          value: 3,
          label: "渠道"
        }
      ]
    };
  },
  methods: {
    ...mapActions(["setRole"]),
    tagetJump() {
      const key = this.role;
      switch (key) {
        case 0:
          this.setRole(0);
          break;
        case 1:
          this.setRole(1);
          this.$router.push("/loginjudge");
          break;
        case 2:
          this.setRole(2);
          this.$router.push("/loginorg");
          break;
        case 3:
          this.setRole(3);
          this.$router.push("/loginchannel");
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-choice {
  height: 100%;
  width: 100%;
  .login-handle {
    // margin-top: 88px;
    .tips {
      font-size: 20px;
      color: #333;
      font-weight: bold;
    }
    .select-area {
      margin-top: 16px;
    }
    .login-btn {
      margin-top: 140px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
<style lang="scss">
.login-choice {
  .el-select,
  .el-input {
    input {
      background-color: #f2f2f2;
      width: 189px;
      height: 32px;
      border-radius: 16px;
      line-height: 33px;
      border: none;
    }
    .el-input__suffix {
      display: flex;
      align-items: center;
    }
  }
  .login-btn {
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
}
</style>
